<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useFormatters } from '@lib/composables/useFormatters'
import type { DashboardEvent } from './dashboard-process'

const props = defineProps<{
    event: DashboardEvent
}>()

const { t } = useI18n()
const { dateTime } = useFormatters()

const percent = computed(() => {
    if (!props.event.ticketsTotal) return 0
    return Math.round((props.event.ticketsUsed / props.event.ticketsTotal) * 100)
})

const dateLabel = computed(() => {
    if (!props.event.startAt) return ''
    return dateTime(props.event.startAt)
})
</script>

<template>
    <RouterLink
        :to="`/tickets?event=${event.id}`"
        class="block p-4 hover:bg-gray-50 transition cursor-pointer"
    >
        <div class="flex items-baseline justify-between mb-1">
            <h3 class="text-sm font-medium text-ink truncate">{{ event.name }}</h3>
            <span class="text-xs text-gray-500 ml-2 whitespace-nowrap">{{ dateLabel }}</span>
        </div>
        <div class="h-2 bg-gray-200 rounded-full overflow-hidden mb-1">
            <div class="h-full bg-teal-600 transition-all" :style="{ width: `${percent}%` }" />
        </div>
        <div class="text-xs text-gray-600">
            {{ t('dashboard.events.progress', { used: event.ticketsUsed, total: event.ticketsTotal, percent }) }}
        </div>
        <div v-if="event.scanRateLastHour > 0" class="text-[11px] text-gray-500 mt-0.5">
            {{ t('dashboard.events.scanRate', { count: event.scanRateLastHour }) }}
        </div>
    </RouterLink>
</template>
